import React from "react";

const Loading = () => {
  return (
    <section className="py-5 loading-sec">
      <div className="container">
        <div className="row">
          <div className="col-10 mx-auto col-md-6">
          <div class="custom-loader"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Loading;
